import React from 'react';
import { RevealOnScroll } from '../ui/RevealOnScroll';
export function Conversation() {
  return <section id="begin" className="bg-ink py-24 md:py-32 px-6" data-id="element-15">
      <div className="container mx-auto max-w-6xl" data-id="element-16">
        <RevealOnScroll className="text-center mb-16 md:mb-24 flex flex-col items-center" data-id="element-17">
          <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-brass mb-6" data-id="element-18">
            CHAPTER FIVE. THE CONVERSATION.
          </p>
          <h2 className="font-serif italic text-parchment text-4xl md:text-[64px] max-w-[700px] leading-[1.2] mb-6" data-id="element-19">
            Sometimes dreams need a hand that can pull them forward.
          </h2>
          <p className="font-mono text-[14px] text-parchment/70 max-w-[480px] leading-[1.8]" data-id="element-20">
            Tell me about the space you imagine. I'll write back.
          </p>
        </RevealOnScroll>

        <div className="flex flex-col md:flex-row gap-16 md:gap-24" data-id="element-21">
          {/* Form Column */}
          <RevealOnScroll className="w-full md:w-[60%] order-2 md:order-1" data-id="element-22">
            <form className="flex flex-col gap-10" onSubmit={e => e.preventDefault()} data-id="element-23">
              <div className="flex flex-col gap-2" data-id="element-24">
                <label className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/80" data-id="element-25">
                  YOUR NAME
                </label>
                <input type="text" className="bg-transparent border-b border-brass/50 text-parchment font-mono text-[14px] py-3 focus:outline-none focus:border-brass transition-colors min-h-[48px]" data-id="element-26" />
              </div>

              <div className="flex flex-col gap-2" data-id="element-27">
                <label className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/80" data-id="element-28">
                  YOUR EMAIL
                </label>
                <input type="email" className="bg-transparent border-b border-brass/50 text-parchment font-mono text-[14px] py-3 focus:outline-none focus:border-brass transition-colors min-h-[48px]" data-id="element-29" />
              </div>

              <div className="flex flex-col gap-2" data-id="element-30">
                <label className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/80" data-id="element-31">
                  THE SPACE
                </label>
                <input type="text" placeholder="a kitchen, a whole home, a feeling..." className="bg-transparent border-b border-brass/50 text-parchment font-mono text-[14px] py-3 focus:outline-none focus:border-brass transition-colors placeholder:text-parchment/30 min-h-[48px]" data-id="element-32" />
              </div>

              <div className="flex flex-col gap-2" data-id="element-33">
                <label className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/80" data-id="element-34">
                  THE PROJECT TYPE
                </label>
                <div className="relative" data-id="element-35">
                  <select className="w-full bg-transparent border-b border-brass/50 text-parchment font-mono text-[14px] py-3 focus:outline-none focus:border-brass transition-colors appearance-none min-h-[48px]" data-id="element-36">
                    <option value="" className="bg-ink text-parchment" data-id="element-37">
                      Select a type...
                    </option>
                    <option value="refresh" className="bg-ink text-parchment" data-id="element-38">
                      The Furniture Refresh
                    </option>
                    <option value="remodel" className="bg-ink text-parchment" data-id="element-39">
                      The Remodel
                    </option>
                    <option value="consultation" className="bg-ink text-parchment" data-id="element-40">
                      The Design Consultation
                    </option>
                  </select>
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-brass font-mono text-[10px]" data-id="element-41">
                    ▼
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-2" data-id="element-42">
                <label className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/80" data-id="element-43">
                  HOW DID YOU FIND ME
                </label>
                <div className="relative" data-id="element-44">
                  <select className="w-full bg-transparent border-b border-brass/50 text-parchment font-mono text-[14px] py-3 focus:outline-none focus:border-brass transition-colors appearance-none min-h-[48px]" data-id="element-45">
                    <option value="" className="bg-ink text-parchment" data-id="element-46">
                      Select an option...
                    </option>
                    <option value="instagram" className="bg-ink text-parchment" data-id="element-47">
                      Instagram
                    </option>
                    <option value="referral" className="bg-ink text-parchment" data-id="element-48">
                      Friend or Colleague
                    </option>
                    <option value="publication" className="bg-ink text-parchment" data-id="element-49">
                      Publication
                    </option>
                    <option value="other" className="bg-ink text-parchment" data-id="element-50">
                      Other
                    </option>
                  </select>
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-brass font-mono text-[10px]" data-id="element-51">
                    ▼
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-2" data-id="element-52">
                <label className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/80" data-id="element-53">
                  TELL ME THE STORY
                </label>
                <textarea rows={4} placeholder="What do you want this space to feel like? Who lives here? What's the dream?" className="bg-transparent border-b border-brass/50 text-parchment font-mono text-[14px] py-3 focus:outline-none focus:border-brass transition-colors resize-none placeholder:text-parchment/30" data-id="element-54"></textarea>
              </div>

              <div className="flex flex-col gap-4 mt-4" data-id="element-55">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-56">
                  <div className="relative flex items-center justify-center w-4 h-4 mt-1 border border-parchment/50 group-hover:border-brass transition-colors" data-id="element-57">
                    <input type="checkbox" className="peer sr-only" data-id="element-58" />
                    <div className="absolute inset-1 bg-brass opacity-0 peer-checked:opacity-100 transition-opacity" data-id="element-59"></div>
                  </div>
                  <span className="font-mono text-[13px] text-parchment/80 leading-[1.6]" data-id="element-60">
                    I'd like to receive transactional updates about my project.
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-61">
                  <div className="relative flex items-center justify-center w-4 h-4 mt-1 border border-parchment/50 group-hover:border-brass transition-colors" data-id="element-62">
                    <input type="checkbox" className="peer sr-only" data-id="element-63" />
                    <div className="absolute inset-1 bg-brass opacity-0 peer-checked:opacity-100 transition-opacity" data-id="element-64"></div>
                  </div>
                  <span className="font-mono text-[13px] text-parchment/80 leading-[1.6]" data-id="element-65">
                    I'd like to receive occasional notes and reflections from
                    the studio.
                  </span>
                </label>
              </div>

              {/* Cloudflare Turnstile Placeholder */}
              <div className="w-full h-[65px] bg-white/5 border border-white/10 flex items-center justify-center mt-4" data-id="element-66">
                <span className="font-mono text-[10px] text-parchment/40" data-id="element-67">
                  CLOUDFLARE TURNSTILE PLACEHOLDER
                </span>
              </div>

              <div className="mt-8" data-id="element-68">
                <button type="submit" className="group inline-flex items-center font-mono lowercase tracking-wide text-brass transition-opacity hover:opacity-80 min-h-[48px]" data-id="element-69">
                  <span className="border-b border-brass pb-0.5 transition-all duration-300 group-hover:border-transparent" data-id="element-70">
                    send the letter &rarr;
                  </span>
                </button>
              </div>

              <p className="font-mono text-[11px] text-parchment/40 mt-8" data-id="element-71">
                or write directly:{' '}
                <a href="mailto:hello@spacesbetween.studio" className="hover:text-parchment transition-colors" data-id="element-72">
                  hello@spacesbetween.studio
                </a>
              </p>
            </form>
          </RevealOnScroll>

          {/* Image Column */}
          <RevealOnScroll className="w-full md:w-[40%] order-1 md:order-2" data-id="element-73">
            <div className="sticky top-32" data-id="element-74">
              <img src="https://cdn.magicpatterns.com/uploads/9SLdDSsbnaZNGcpwaG83jy/spaces-design1.jpg" alt="Leather chair in interior" className="w-full aspect-[3/4] object-cover grayscale opacity-80" data-id="element-75" />
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </section>;
}